export const _LOAD_MODEL_ = 'Load:User';
export const _SAVE_MODEL_ = 'Save:User';
export const _DELETE_USER_ = 'Delete:User';

export const MODEL = {
  id: null,
  name: '',
  email: '',
  phone: '',
  old_password: '',
  password: '',
  password_confirmation: '',
  settings: {
    id: null,
    role_id: null,
    user_type_id: 2,
    image_id: null,
    role: {
      id: null,
      name: 'Nenhum',
      slug: null,
    },
    type: {
      id: 2,
      name: 'General',
      slug: 'general',
    },
    image: {
      id: null,
      name: null,
      url: require('@/assets/images/avatars/enhanced-buzz.jpeg'),
    },
  },
};
